import React from 'react';
import { TabPanel, Text } from "@chakra-ui/react";

const Profile = () => {
    return (
        <TabPanel>
            <Text>Profile</Text>
        </TabPanel>
    );
};

export default Profile;